/**
 * 识别"分块没加载出来"的错误
 * ---------------------------------------------------------------------------
 * 和 error-boundary.tsx 分开放，是为了配合 React Fast Refresh：
 * 组件文件里只导出组件，纯函数放这里，热更新时不会整页刷新。
 * （auth-store.ts、toast-store.ts 是同样的拆法。）
 *
 * 按路由做代码分包之后，切页面要现拉一个 JS 分块。两种情况会失败：
 *   - 门店 WiFi 抖了一下；
 *   - 刚发过版，浏览器还拿着旧的 index.html 去要已经被替换掉的旧分块。
 * 这两种刷新一下就好，和真正的代码 bug 要给不同的提示——
 * 认错了的后果是：真的是网络问题却让人去找客服，或者真的是 bug 却让人一直点刷新。
 *
 * 下面这些措辞是各浏览器实测来的：
 *   Chrome / Edge  Failed to fetch dynamically imported module: …
 *   Safari         Importing a module script failed.
 *   Firefox        error loading dynamically imported module
 *   webpack 系      ChunkLoadError / Loading chunk 12 failed
 * 静态托管常见的 SPA 兜底（把 404 的 .js 回成 index.html）会让浏览器报
 * MIME 类型错误，实测过一次，所以也归到这一类。
 */
export function isChunkLoadError(error: Error): boolean {
  const text = `${error.name} ${error.message}`;
  return (
    /ChunkLoadError/i.test(text) ||
    /Loading chunk/i.test(text) ||
    /dynamically imported module/i.test(text) ||
    /module script failed/i.test(text) ||
    /MIME type|text\/html/i.test(text)
  );
}
